import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { DocumentType, documentTypeList } from '../../../core/models/user.model';
import { UserService, UserServiceState } from '../../../core/services/user.service';
import { DateFormatter } from '../../../utils/DateFormatter';
import { Portal } from '../../../shared/layout/portal/portal';
import { SimService } from '../../../core/services/sim.service';

@Component({
  selector: 'app-manual-activation',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatIconModule,
    MatNativeDateModule,
    Portal,
  ],
  templateUrl: './manual-activation.html',
  styleUrl: './manual-activation.scss',
})
export class ManualActivation implements OnInit {
  dateFormatter = new DateFormatter();
  maxDate: Date = new Date();
  activationForm!: FormGroup;
  step: 'form' | 'confirmation' = 'form';
  editMode: { [key: string]: boolean } = {
    names: false,
    lastNames: false,
    documentType: false,
    id: false,
    expeditionDate: false,
    birthDate: false,
    email: false,
  };

  documentType = documentTypeList;
  isLoading: boolean = false;
  currentUser: UserServiceState | null = null;

  readonly dialog = inject(MatDialog);
  private router = inject(Router);

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private simService: SimService
  ) {
     this.userService.currentUser$.subscribe((data) => {
      this.currentUser = data;
    });
  }

  ngOnInit(): void {
    this.activationForm = this.fb.group({
      documentType: ['', Validators.required],
      id: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
      expeditionDate: ['', Validators.required],
      names: [''],
      lastNames: [''],
      birthDate: [''],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  handleNext(): void {
    this.activationForm.markAllAsTouched();
    if (this.activationForm.valid) {
      this.step = 'confirmation';
    }
  }

  toggleEdit(field: string): void {
    this.editMode[field] = !this.editMode[field];
    if (this.editMode[field]) {
      // If editing is enabled, focus the input field
      setTimeout(() => {
        const inputElement = document.getElementById(`edit-${field}`);
        if (inputElement) {
          inputElement.focus();
        }
      }, 0);
    }
  }

  onSubmit(): void {
    this.isLoading = true;
    if (this.activationForm.valid) {
        this.userService.setState({
                          user: {
                            ...this.currentUser?.user,
                            firstName: this.activationForm.get('names')?.value,
                            lastName: this.activationForm.get('lastNames')?.value,
                            identificationNumber: this.activationForm.get('id')?.value,
                            identificationType: this.activationForm.get('documentType')?.value,
                            issueDate: this.dateFormatter.getDottedDDMMYYYY(this.activationForm.get('expeditionDate')?.value),
                            email: this.activationForm.get('email')?.value,
                            birthday: this.dateFormatter.getDottedDDMMYYYY(this.activationForm.get('birthDate')?.value),
                            identityVerified: false,
                          },
                          valid: false
                        })
                        const activateSimCardData = {...this.currentUser!.user!};
                        if(this.currentUser!.user!.identificationType === DocumentType.NIT){
                          delete activateSimCardData.issueDate;
                        }
                         this.simService.activateSimCard(activateSimCardData)
              .subscribe(data=> {
                if(data.success){
                  this.isLoading = false;
                  this.router.navigate(['activation-success']); 
                }
                this.isLoading = false;
              },err => console.log(err))
    } else {
      console.error('El formulario es inválido. Por favor, revisa tus datos.');
      this.step = 'form';
      this.isLoading = false;
    }
  }
}
